import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import { awsConfig } from '@/config/aws';
import { TemaProvider } from '@/contexts/TemaContext';
import App from './App';
import './index.css';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: awsConfig.userPoolId,
      userPoolClientId: awsConfig.userPoolClientId,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Acima do App: o tema vale para a tela de login também, e para o
        fallback de carregamento das rotas preguiçosas. */}
    <TemaProvider>
      <App />
    </TemaProvider>
  </StrictMode>,
);
